import React from 'react'
import SubresellersContainer from 'containers/panel/admin/subresellers-container'

const SubresellersPage = () => {
  return (
    <SubresellersContainer/>
  )
}

export default SubresellersPage